import { useNavigate } from 'react-router-dom'

import { ResourceHeader } from '@factorialco/f0-react/dist/experimental'
import { Pencil } from '@factorialco/f0-react/icons/app'
import { ApprovalsGroupFragment } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

interface ApprovalGroupDetailHeaderProps {
  approvalGroup: ApprovalsGroupFragment
  ctaLink: string
}

export const ApprovalGroupDetailHeader = ({
  approvalGroup,
  ctaLink,
}: ApprovalGroupDetailHeaderProps) => {
  const navigate = useNavigate()

  return (
    <ResourceHeader
      title={approvalGroup.name}
      description={approvalGroup.description ?? ''}
      secondaryActions={[
        {
          label: i18n.t('settings.approvals.approval_group.modify'),
          icon: Pencil,
          onClick: () => navigate(ctaLink),
        },
      ]}
    />
  )
}
